import { Component, Input, EventEmitter, Output } from '@angular/core';
import { urlIsValid } from '../../helpers/helpers';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { CommonModule } from '@angular/common';
import { FileLinkComponent } from '../file-handler/file-link.component';

@Component({
    selector: 'edit-link',
    template: `
<ng-container>
  <div class="field-name">
    <span *ngIf="!!title"> {{ title }}</span>
    <ng-content></ng-content>
    <div class="invalid" *ngIf="!!linkInvalid">Link is invalid (needs to start with http(s)://)</div>
  </div>
  <div style="flex:1"></div>
</ng-container>
<div class="link-holder">
  <joi-input  
    [(model)]="link"
    [fixedWidth]="true"
    [placeholder]="placeholder" 
    (joiChange)="updateLink()"
  ></joi-input>
  <file-link *ngIf="!linkInvalid && !!link" [onlyLink]="true" [onlyOpenInNew]="true" [file]="{ linkUrl: link }"></file-link>
</div>
`,
    styles: [`
:host { display: flex; align-items: center; padding-bottom: 10px; display: flex; flex-wrap: nowrap; white-space: nowrap; }
.link-holder { display: flex; align-items: center; margin-left: 20px; }
.field-name { position: relative; }
.invalid { position: absolute; white-space: nowrap; bottom: -18px; font-size: 11px; color: var(--warn); left: 0px; }
joi-input { width: 200px; }
`],
    standalone: true,
    imports: [JoiInputComponent, CommonModule, FileLinkComponent],
})
export class EditLinkComponent {
  @Input() link: string
  @Input() title: string
  @Input() placeholder: string = 'Link to quote...'
  @Output() saveLink: EventEmitter<string> = new EventEmitter()
  linkInvalid = false


  updateLink() {
    this.linkInvalid = !urlIsValid(this.link)
    if (!this.linkInvalid) this.saveLink.emit(this.link)
  }

}